
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/peri-products",
      function () {
        return require("private-next-pages/peri-products/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/peri-products"])
      });
    }
  